export const MobileMedia: string = '(max-width: 767px)';
